import { render, staticRenderFns } from "./Keywordrole1.vue?vue&type=template&id=43b2a4e2&scoped=true"
import script from "./Keywordrole1.vue?vue&type=script&lang=js"
export * from "./Keywordrole1.vue?vue&type=script&lang=js"
import style0 from "./Keywordrole1.vue?vue&type=style&index=0&id=43b2a4e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b2a4e2",
  null
  
)

export default component.exports